module.exports = __webpack_public_path__ + "band_14_daughter.4d218f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_14_daughter.png
// module id = rqJY
// module chunks = 0